export default {
  form: {
    agreement: {
      label:
        'Reconozco que proporcionar mi aprobación electrónica equivale a firmar este documento y entiendo que mi firma electrónica es vinculante.',
    },
    signed_by: {
      label: 'Nombre',
      placeholder: 'Nombre',
    },
    signer_first_name: {
      label: 'Nombre',
      placeholder: 'Nombre',
    },
    signer_last_name: {
      label: 'Apellido',
      placeholder: 'Apellido',
    },
    recipient_email: {
      label: 'Correo electrónico del destinatario',
      placeholder: 'Introduce el correo electrónico',
    },
    send_to_email: {
      label: 'Enviar contrato al propietario por correo ({{email}})',
    },
    additional_locations: {
      label: 'Ubicaciones adicionales',
      placeholder: 'Buscar una ubicación para añadir',
    },
    special_agreements: {
      label: 'Acuerdos especiales',
      placeholder: 'Introduce acuerdos especiales',
    },
  },
  labels: {
    name: 'Nombre',
    date: 'Fecha',
  },
  buttons: {
    sign_in_person: 'Firmar aquí con el propietario',
    back: 'Atrás',
    edit_contract: 'Editar contrato',
    skip: 'Omitir',
    sign: 'Firmar',
    init_sign: 'Crear contrato y enviar',
    redo: 'Rehacer',
    continue: 'Continuar',
    preview: 'Vista previa',
    submit: 'Enviar',
  },
  toasts: {
    failed_to_preview_contract: 'Error al previsualizar el contrato',
    contract_signing_pending: 'Un momento, estamos iniciando tu contrato...',
    failed_to_sign_contract: 'Error al iniciar el contrato ⁉️',
    contract_got_signed: 'Contrato iniciado 👌',
  },
  in_person_signing: {
    description:
      'El propietario ha recibido este enlace por correo electrónico y puede firmar de forma remota. Si el propietario está contigo ahora, abre aquí la página de firma.',
  },
  signature_link: {
    label: 'Enlace de firma (mismo enlace enviado al destinatario por correo)',
    copy: 'Copiar',
    copied: 'Enlace de firma copiado al portapapeles',
  },
  header: 'Crear contrato',
  description: 'Revisa los detalles del contrato e introduce el correo al que debe enviarse.',
};
